export default {
  warning:
    'Este local no está asignado a una marca. Para que el sistema funcione correctamente, el local debe pertenecer a una. Añade este local a una marca.',
  cta: 'Ir a marcas',
};
